const eventListenerKey = (eventType) => `LandrEvent.${eventType}`;
function addLandrEventListener(eventType, callback) {
    const eventKey = eventListenerKey(eventType);
    const onMessage = (event) => {
        if (event.data.type === eventKey) {
            callback(event.data.payload);
        }
    };
    window.addEventListener('message', onMessage);
    return () => {
        window.removeEventListener('message', onMessage);
    };
}
function broadcastLandrEvent(eventType, payload) {
    const eventKey = eventListenerKey(eventType);
    window.postMessage({
        type: eventKey,
        payload,
    }, '*');
}

export { addLandrEventListener, broadcastLandrEvent };
